import { each, pipe } from '@fxts/core';

const toDate = (value: string | Date | null | undefined): Date | null => {
  if (value === null || value === undefined) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value === 'string') {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  throw new Error('hydrateSafetyDate toDate Error');
};

export function hydrateSafetyDate<T extends Record<string, any>>(obj: T, dateFields: (keyof T)[]): T {
  const result = { ...obj };

  pipe(
    dateFields,
    each((field) => {
      if (field in result) result[field] = toDate(result[field]) as T[typeof field];
    }),
  );

  return result;
}
